import { Typography } from "antd";
import type { MutableRefObject, ReactNode } from "react";

interface FocusOverlayProps {
  title: string;
  children: ReactNode;
  containerRef?: MutableRefObject<HTMLDivElement | null>;
}

const FocusOverlay = ({ title, children, containerRef }: FocusOverlayProps) => (
  <div
    ref={containerRef}
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 2000,
      background: "var(--ant-color-bg-layout)",
      padding: 24,
      overflow: "auto",
      display: "flex",
      flexDirection: "column",
      gap: 16,
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 12,
      }}
    >
      <Typography.Title level={4} style={{ margin: 0 }}>
        {title}
      </Typography.Title>
    </div>
    {children}
  </div>
);

export default FocusOverlay;
